window.addEventListener("variantChangeEnd", function (e) {
  const variantId = String(e.target.currentVariant?.id || "");
  const sectionId = e.target.dataset.section;
  if (!variantId || !sectionId) return;

  console.log("variantChangeEnd", { sectionId, variantId });

  // Scope to the correct product section (important for featured products, quick view, etc.)
  const sectionRoot = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!sectionRoot) return;

  // Find ONLY the ingredients tab’s JSON (after Liquid change, there should be one)
  const dataScript = sectionRoot.querySelector('[data-variant-ingredients]');
  if (!dataScript) return;

  // Find ONLY the ingredients content container inside the same collapsible-section
  const collapsible = dataScript.closest("collapsible-section");
  if (!collapsible) return;

  const ingredientContainer = collapsible.querySelector('[data-ingredients-content]');
  if (!ingredientContainer) return;

  const data = JSON.parse(dataScript.textContent);

  const variantIngredient = data.variants?.[variantId]?.ingredient;
  const productIngredient = data.productIngredients;

  ingredientContainer.innerHTML =
    variantIngredient && variantIngredient.trim() !== ""
      ? variantIngredient
      : productIngredient;
});
